import * as React from 'react';
import currency from 'currency.js';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';

import './cca-bulk-subtotal.scss';

applyTranslations(require('./cca-bulk-subtotal.i18n.json'));

type Props = {
  totalEnteredPercentage: number
};

const CCABulkSubtotal = ({ totalEnteredPercentage }: Props): JSX.Element => {
  const percentsLeft = currency(100).subtract(currency(totalEnteredPercentage)).value;
  const remainingClassnames = classnames('cca-bulk-subtotal__remaining', {
    'cca-bulk-subtotal__remaining--exceeded': percentsLeft < 0
  });

  return (
    <div className="cca-bulk-subtotal">
      <div className="cca-bulk-subtotal__section">
        <div className="cca-bulk-subtotal__values">
          {__t('cca_bulk_subtotal.total_label')}
        </div>
        <div className="cca-bulk-subtotal__values">
          {totalEnteredPercentage}%
        </div>
      </div>
      <div className="cca-bulk-subtotal__section">
        <div className="cca-bulk-subtotal__error-message">
          {(percentsLeft < 0) ? __t('cca_bulk_subtotal.match_error') : ''}
        </div>
        <div className={remainingClassnames}>
          {__t('cca_bulk_subtotal.remaining_percentage', {
            percentsLeft
          })}
        </div>
      </div>
    </div>
  );
};

export default CCABulkSubtotal;
